<template>
  <div>
    <v-text-field
      class="mt-2"
      v-model="subjectLocal"
      outlined
      auto-grow
      :readonly="readonly"
      :label="$t('components.template.editor.subject')"
    >
      <template #append>
        <template-editor-add-placeholder
          v-if="addPlaceholderInSubject"
          @addPlaceholder="addPlaceholderToSubject"
          :partnerId="partnerId"
          class="mt-n2"
        />
      </template>
    </v-text-field>
    <v-card-actions class="mt-n10">
      <v-spacer />
      <small :style="subjectCounterStyle"> {{ subjectLength }}/60 </small>
    </v-card-actions>
  </div>
</template>

<script lang="ts">
import { EditorContent } from "@tiptap/vue-2";
import { Component, Prop, Vue } from "vue-property-decorator";
import Card from "../utility/Card.vue";
import TemplateEditorActions from "./TemplateEditorActions.vue";
import TemplateEditorAddPlaceholder from "./TemplateEditorAddPlaceholder.vue";

@Component({
  components: { EditorContent, Card, TemplateEditorAddPlaceholder, TemplateEditorActions }
})
export default class TemplateEditorSubject extends Vue {
  @Prop()
  partnerId?: string;

  @Prop()
  subject!: string;

  @Prop({ default: false })
  addPlaceholderInSubject?: boolean;

  @Prop({ default: false })
  readonly?: boolean;

  get subjectLocal() {
    return this.subject;
  }

  set subjectLocal(s: string) {
    this.$emit("update:subject", s);
  }

  get subjectLength() {
    return this.subjectLocal?.length || 0;
  }

  get subjectCounterStyle() {
    const color = this.subjectLocal?.length || 0 > 60 ? "orange" : "green";

    return `color: ${color}`;
  }

  addPlaceholderToSubject(placeholder: string) {
    this.subjectLocal += placeholder;
  }
}
</script>

<style scoped>
.tipTapStyle {
  border-style: solid;
  border-color: var(--grey-lighten-5);
  border-width: 1px;
  border-radius: 5px;
  margin-left: 1px;
  margin-right: 1px;
  height: calc(100% - 80px);
}
.tipTapStyle:hover {
  border-color: black;
}
</style>

<style>
.ProseMirror:focus {
  outline: none;
}
.ProseMirror {
  padding: 22px;
  height: 100%;
  overflow: scroll;
}
</style>
<!--  -->
